import { DashboardLayout } from "@/projects/components/dashboard-layout";
import { Card } from "@/projects/components/ui/card";
import { Download } from "lucide-react";

export function AdminExportsPage() {
  return (
    <DashboardLayout
      role="admin"
      title="Export History"
      breadcrumb={["Home", "Export History"]}
    >
      <Card className="p-6">
        <div className="grid gap-3">
          {[
            {
              file: "submissions-all-2026-07-10.csv",
              by: "Super Admin",
              count: 20,
              date: "10 Jul 2026",
            },
            {
              file: "submissions-filtered-2026-07-08.csv",
              by: "Super Admin",
              count: 8,
              date: "08 Jul 2026",
            },
            {
              file: "reports-reward-2026-07-05.csv",
              by: "Super Admin",
              count: 5,
              date: "05 Jul 2026",
            },
          ].map(e => (
            <div
              key={e.file}
              className="bg-muted/30 flex items-center justify-between rounded-lg border p-3"
            >
              <div className="flex items-center gap-3">
                <div className="bg-royal-soft text-royal grid h-10 w-10 place-items-center rounded-lg">
                  <Download className="h-4 w-4" />
                </div>
                <div>
                  <div className="font-medium">{e.file}</div>
                  <div className="text-muted-foreground text-xs">
                    {e.count} records · exported by {e.by} · {e.date}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </Card>
    </DashboardLayout>
  );
}
